import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { Lang_$reflection } from "./Shopfoo.Domain.Types/Common.js";
import { FullContext__get_Lang, HomeApi_GetTranslationsRequest, FullContext as FullContext_3, FullContext__WithAnonymousUser, FullContext__WithPersona_Z485AB5E3, FullContext__FillTranslations_Z288CEB4, FullContext_get_Default, FullContext_$reflection, AuthPersona_$reflection, HomeApi_GetTranslationsResponse_$reflection } from "./Shopfoo.Shared/Remoting.js";
import { Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505, Remote$1, ApiRequestArgs$2, ApiCall$1, Cmder__ofApiRequest_Z503C4AF9, ApiCall$1_$reflection } from "./Remoting.js";
import { Translations_$reflection } from "./Shopfoo.Domain.Types/Translations.js";
import { ThemeDropdown, Theme__ApplyOnHtml_Z12EEBC6C, Theme, Theme_$reflection } from "./Components/Theme.js";
import { Page_CurrentNotFound, Router_navigatePage, Page, Page_get_ProductIndexDefaults, Cmd_navigatePage, PageModule_parseFromUrlSegments, Page_$reflection } from "./Routing.js";
import { Toast as Toast_3, Toast_$reflection } from "./Pages/Shared.js";
import { class_type, record_type, option_type, list_type, union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { LangDropdown, LangMenu, LangMenuModule_all, LangMenu_$reflection } from "./Components/Lang.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { RouterModule_router, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { find, ofArray, singleton } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { empty, append, singleton as singleton_1, collect, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { createObj, equals } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { TranslationPages_Home__get_ChangeLangOk, TranslationPages_Home__ChangeLangError_Z384F8060, TranslationPages_Product__get_Stock, TranslationPages_Product__get_SaleAction, AppTranslations__get_Product, TranslationPages_Product__get_Price, TranslationPages_Home__get_Product, TranslationPages_Home__SavedOk_Z721C83C5, TranslationPages_Home__SavedError_Z384F8060, TranslationPages_Home__get_About, AppTranslations__get_Home, TranslationPages_Home__get_Admin, AppTranslations__get_IsEmpty, AppTranslations__get_PopulatedPages, AppTranslations_$ctor, AppTranslations__Fill_Z288CEB4 } from "./Shopfoo.Shared/Translations.js";
import { User__CanAccess_Z21948E14, Feat } from "./Shopfoo.Domain.Types/Security.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { React_useElmish_Z6C327F2E } from "./fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "./fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { AboutView } from "./Pages/About.js";
import { AdminView } from "./Pages/Admin.js";
import { LoginView } from "./Pages/Login.js";
import { NotFoundView } from "./Pages/NotFound.js";
import { ProductDetailsView } from "./Pages/Product/Details/Page.js";
import { ProductIndexView } from "./Pages/Product/Index/Page.js";
import { AppNavBar } from "./Components/AppNav.js";
import { UserDropdown } from "./Components/User.js";
import { Helpers_combineClasses } from "./fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { icon } from "./Components/Icon.js";
import gear from "@iconify-icons/fa6-solid/gear";
import circle_info from "@iconify-icons/fa6-solid/circle-info";
import { Toast as Toast_4, Dismiss } from "./Components/Toast.js";
import { now, getTicks } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { createRoot } from "react-dom/client";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ChangeLang", "FillTranslations", "Login", "Logout", "ThemeChanged", "UrlChanged", "ToastOn", "ToastOff"];
    }
}

export function Msg_$reflection() {
    return union_type("Shopfoo.Client.View.Msg", [], Msg, () => [[["Item1", Lang_$reflection()], ["Item2", ApiCall$1_$reflection(HomeApi_GetTranslationsResponse_$reflection())]], [["Item", Translations_$reflection()]], [["Item", AuthPersona_$reflection()]], [], [["Item", Theme_$reflection()]], [["Item", Page_$reflection()]], [["Item", Toast_$reflection()]], []]);
}

export class Model extends Record {
    constructor(Page, Theme, FullContext, LangMenus, Toast) {
        super();
        this.Page = Page;
        this.Theme = Theme;
        this.FullContext = FullContext;
        this.LangMenus = LangMenus;
        this.Toast = Toast;
    }
}

export function Model_$reflection() {
    return record_type("Shopfoo.Client.View.Model", [], Model, () => [["Page", Page_$reflection()], ["Theme", Theme_$reflection()], ["FullContext", FullContext_$reflection()], ["LangMenus", list_type(LangMenu_$reflection())], ["Toast", option_type(Toast_$reflection())]]);
}

export function Cmd_fetchTranslations(cmder, request) {
    const lang = request.Body.Lang;
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Home.GetTranslations(request), (err) => (new Msg(0, [lang, new ApiCall$1(1, [new FSharpResult$2(1, [err])])])), (data) => (new Msg(0, [lang, new ApiCall$1(1, [new FSharpResult$2(0, [data])])]))));
}

export function init() {
    const currentPage = PageModule_parseFromUrlSegments(RouterModule_urlSegments(window.location.pathname + window.location.search, 2));
    const defaultTheme = new Theme(1, []);
    return [new Model(currentPage, defaultTheme, FullContext_get_Default(), LangMenuModule_all, undefined), Cmd_batch(ofArray([Cmd_navigatePage(currentPage), singleton((dispatch) => {
        dispatch(new Msg(4, [defaultTheme]));
    })]))];
}

export function update(msg, model) {
    let bind$0040, tupledArg;
    const updateLangStatus = (lang, status) => toList(delay(() => collect((menu) => (equals(menu.Lang, lang) ? singleton_1(new LangMenu(menu.Lang, menu.Code, menu.Label, menu.Emoji, status)) : singleton_1(menu)), model.LangMenus)));
    switch (msg.tag) {
        case 1:
            return [new Model(model.Page, model.Theme, FullContext__FillTranslations_Z288CEB4(model.FullContext, msg.fields[0]), model.LangMenus, model.Toast), Cmd_none()];
        case 2:
            return [new Model(model.Page, model.Theme, FullContext__WithPersona_Z485AB5E3(model.FullContext, msg.fields[0]), model.LangMenus, model.Toast), (model.Page.tag === 3) ? Cmd_navigatePage(Page_get_ProductIndexDefaults()) : Cmd_none()];
        case 3:
            return [new Model(model.Page, model.Theme, FullContext__WithAnonymousUser(model.FullContext), model.LangMenus, model.Toast), Cmd_navigatePage(new Page(3, []))];
        case 4:
            return [new Model(model.Page, msg.fields[0], model.FullContext, model.LangMenus, model.Toast), Cmd_ofEffect((_arg) => {
                Theme__ApplyOnHtml_Z12EEBC6C(msg.fields[0]);
            })];
        case 5:
            return [new Model(msg.fields[0], model.Theme, model.FullContext, model.LangMenus, model.Toast), Cmd_none()];
        case 6:
            return [new Model(model.Page, model.Theme, model.FullContext, model.LangMenus, msg.fields[0]), Cmd_none()];
        case 7:
            return [new Model(model.Page, model.Theme, model.FullContext, model.LangMenus, undefined), Cmd_none()];
        default:
            if (msg.fields[1].tag === 1) {
                if (msg.fields[1].fields[0].tag === 1) {
                    return [new Model(model.Page, model.Theme, model.FullContext, updateLangStatus(msg.fields[0], new Remote$1(2, [msg.fields[1].fields[0].fields[0]])), model.Toast), singleton((dispatch_1) => {
                        dispatch_1(new Msg(6, [new Toast_3(0, [msg.fields[0]])]));
                    })];
                }
                else {
                    return [new Model(model.Page, model.Theme, (bind$0040 = model.FullContext, new FullContext_3(bind$0040.User, bind$0040.Token, AppTranslations__Fill_Z288CEB4(AppTranslations_$ctor(), msg.fields[1].fields[0].fields[0].Translations), bind$0040.UnitTestSession)), updateLangStatus(msg.fields[0], new Remote$1(3, [undefined])), model.Toast), Cmd_batch(ofArray([singleton((dispatch) => {
                        dispatch(new Msg(6, [new Toast_3(0, [msg.fields[0]])]));
                    }), Cmd_navigatePage(new Page(3, [])), Cmd_navigatePage(model.Page)]))];
                }
            }
            else {
                return [new Model(model.Page, model.Theme, model.FullContext, updateLangStatus(msg.fields[0], new Remote$1(1, [])), undefined), (tupledArg = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(model.FullContext, new HomeApi_GetTranslationsRequest(msg.fields[0], AppTranslations__get_PopulatedPages(model.FullContext.Translations))), Cmd_fetchTranslations(tupledArg[0], tupledArg[1]))];
            }
    }
}

class Env {
    constructor(fullContext, dispatch) {
        this.fullContext = fullContext;
        this.dispatch = dispatch;
    }
    get FullContext() {
        const _ = this;
        return _.fullContext;
    }
    FillTranslations(translations) {
        const _ = this;
        _.dispatch(new Msg(1, [translations]));
    }
    Login(persona) {
        const _ = this;
        _.dispatch(new Msg(2, [persona]));
    }
    ShowToast(toast) {
        const _ = this;
        _.dispatch(new Msg(6, [toast]));
    }
}

function Env_$reflection() {
    return class_type("Shopfoo.Client.View.Env", undefined, Env);
}

function Env_$ctor_Z1E2436DD(fullContext, dispatch) {
    return new Env(fullContext, dispatch);
}

export function resolvePageAccess(page, user) {
    let matchResult;
    switch (page.tag) {
        case 3: {
            if (user.tag === 1) {
                matchResult = 3;
            }
            else {
                matchResult = 0;
            }
            break;
        }
        case 5: {
            if (user.tag === 0) {
                matchResult = 4;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 6: {
            if (user.tag === 0) {
                matchResult = 4;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 1: {
            if (user.tag === 0) {
                matchResult = 4;
            }
            else {
                matchResult = 2;
            }
            break;
        }
        case 2: {
            if (user.tag === 0) {
                matchResult = 4;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return [page, undefined];
        case 1:
            return [page, new Feat(2, [])];
        case 2:
            return [page, new Feat(1, [])];
        case 3:
            return [Page_get_ProductIndexDefaults(), new Feat(2, [])];
        default:
            return [new Page(3, []), undefined];
    }
}

export function AppView() {
    let elements;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const fullContext = model_1.FullContext;
    const translations = fullContext.Translations;
    const env = Env_$ctor_Z1E2436DD(fullContext, dispatch);
    const patternInput_1 = resolvePageAccess(model_1.Page, fullContext.User);
    const pageToDisplayInline = patternInput_1[0];
    const featAccessToCheck = patternInput_1[1];
    reactApi.useEffect(() => {
        let matchResult, feat_1;
        if (featAccessToCheck != null) {
            if (!User__CanAccess_Z21948E14(fullContext.User, featAccessToCheck)) {
                matchResult = 0;
                feat_1 = featAccessToCheck;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                Router_navigatePage(Page_CurrentNotFound());
                break;
            }
            case 1: {
                break;
            }
        }
    });
    const pageView = (pageToDisplayInline.tag === 0) ? createElement(AboutView, {
        env: env,
    }) : ((pageToDisplayInline.tag === 1) ? createElement(AdminView, {
        env: env,
    }) : ((pageToDisplayInline.tag === 3) ? createElement(LoginView, {
        env: env,
    }) : ((pageToDisplayInline.tag === 4) ? createElement(NotFoundView, {
        env: env,
        url: pageToDisplayInline.fields[0],
    }) : ((pageToDisplayInline.tag === 6) ? createElement(ProductDetailsView, {
        env: env,
        sku: pageToDisplayInline.fields[0],
    }) : ((pageToDisplayInline.tag === 5) ? createElement(ProductIndexView, {
        env: env,
        filters: pageToDisplayInline.fields[0],
    }) : "[Bug] Home page has no own view!?")))));
    const navbar = createElement(AppNavBar, {
        key: "app-nav",
        $key: "app-nav",
        currentPage: model_1.Page,
        pageDisplayedInline: pageToDisplayInline,
        translations: translations,
        children: toList(delay(() => {
            let matchValue;
            return append((matchValue = fullContext.User, (matchValue.tag === 1) ? singleton_1(createElement(UserDropdown, {
                key: "nav-user",
                $key: "nav-user",
                userName: matchValue.fields[0],
                translations: translations,
                onClick: () => {
                    dispatch(new Msg(3, []));
                },
            })) : (empty())), delay(() => append(singleton_1(createElement(LangDropdown, {
                key: "nav-lang",
                $key: "nav-lang",
                currentLang: FullContext__get_Lang(fullContext),
                menus: model_1.LangMenus,
                onClick: (lang) => {
                    dispatch(new Msg(0, [lang, new ApiCall$1(0, [])]));
                },
            })), delay(() => append(singleton_1(createElement(ThemeDropdown, {
                key: "nav-theme",
                $key: "nav-theme",
                theme: model_1.Theme,
                translations: translations,
                onClick: (arg) => {
                    dispatch(new Msg(4, [arg]));
                },
            })), delay(() => (!AppTranslations__get_IsEmpty(translations) ? append(User__CanAccess_Z21948E14(fullContext.User, new Feat(1, [])) ? singleton_1(createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-ghost"], ["key", "nav-admin"], ["className", "opacity-70 hover:opacity-100"], ["children", icon(gear)], ["title", TranslationPages_Home__get_Admin(AppTranslations__get_Home(translations))], ["onClick", (_arg_2) => {
                Router_navigatePage(new Page(1, []));
            }]]))))) : empty(), delay(() => singleton_1(createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-ghost"], ["key", "nav-about"], ["className", "opacity-70 hover:opacity-100"], ["children", icon(circle_info)], ["title", TranslationPages_Home__get_About(AppTranslations__get_Home(translations))], ["onClick", (_arg_3) => {
                Router_navigatePage(new Page(0, []));
            }]]))))))) : empty())))))));
        })),
    });
    const onDismiss = () => {
        dispatch(new Msg(7, []));
    };
    const toast = (name_4, error) => {
        let patternInput_2;
        if (error != null) {
            const err = error;
            patternInput_2 = [["className", "alert-error"], TranslationPages_Home__SavedError_Z384F8060(AppTranslations__get_Home(translations), name_4, err.ErrorMessage), new Dismiss(1, [])];
        }
        else {
            patternInput_2 = [["className", "alert-success"], TranslationPages_Home__SavedOk_Z721C83C5(AppTranslations__get_Home(translations), name_4), new Dismiss(0, [])];
        }
        const $key68B67CB7 = `toast-${getTicks(now())}`;
        return createElement(Toast_4, {
            key: $key68B67CB7,
            $key: $key68B67CB7,
            alertProps: [patternInput_2[0]],
            dismiss: patternInput_2[2],
            onDismiss: onDismiss,
            children: [patternInput_2[1]],
        });
    };
    return RouterModule_router(createObj(ofArray([["hashMode", 2], ["onUrlChanged", (arg_2) => {
        dispatch(new Msg(5, [PageModule_parseFromUrlSegments(arg_2)]));
    }], (elements = toList(delay(() => append(singleton_1(navbar), delay(() => append(singleton_1(createElement("div", {
        key: "app-content",
        className: "px-4 py-2",
        children: pageView,
    })), delay(() => {
        const matchValue_1 = model_1.Toast;
        if (matchValue_1 != null) {
            switch (matchValue_1.tag) {
                case 2: {
                    const error_2 = matchValue_1.fields[1];
                    const product = matchValue_1.fields[0];
                    return singleton_1(toast(`${TranslationPages_Home__get_Product(AppTranslations__get_Home(translations))} ${product.SKU.Value}`, error_2));
                }
                case 1: {
                    const error_3 = matchValue_1.fields[1];
                    const prices = matchValue_1.fields[0];
                    return singleton_1(toast(`${TranslationPages_Product__get_Price(AppTranslations__get_Product(translations))} ${prices.SKU.Value}`, error_3));
                }
                case 3: {
                    const error_4 = matchValue_1.fields[1];
                    const sku_1 = matchValue_1.fields[0];
                    return singleton_1(toast(`${TranslationPages_Product__get_SaleAction(AppTranslations__get_Product(translations)).InputSales} ${sku_1.Value}`, error_4));
                }
                case 4: {
                    const error_5 = matchValue_1.fields[1];
                    const stock = matchValue_1.fields[0];
                    return singleton_1(toast(`${TranslationPages_Product__get_Stock(AppTranslations__get_Product(translations))} ${stock.SKU.Value}`, error_5));
                }
                case 5: {
                    const error_6 = matchValue_1.fields[1];
                    const sku_2 = matchValue_1.fields[0];
                    return singleton_1(toast(`${TranslationPages_Product__get_Stock(AppTranslations__get_Product(translations))} ${sku_2.Value}`, error_6));
                }
                default: {
                    const lang_1 = matchValue_1.fields[0];
                    const langMenu = find((menu) => equals(menu.Lang, lang_1), model_1.LangMenus);
                    const langToast = (error_1) => {
                        let patternInput_3;
                        if (error_1 != null) {
                            const err_1 = error_1;
                            patternInput_3 = [["className", "alert-error"], TranslationPages_Home__ChangeLangError_Z384F8060(AppTranslations__get_Home(translations), langMenu.Label, err_1.ErrorMessage), new Dismiss(1, [])];
                        }
                        else {
                            patternInput_3 = [["className", "alert-success"], TranslationPages_Home__get_ChangeLangOk(AppTranslations__get_Home(translations)), new Dismiss(0, [])];
                        }
                        const $keyZ168450D4 = `toast-lang-${getTicks(now())}`;
                        return createElement(Toast_4, {
                            key: $keyZ168450D4,
                            $key: $keyZ168450D4,
                            alertProps: [patternInput_3[0]],
                            dismiss: patternInput_3[2],
                            onDismiss: onDismiss,
                            children: [patternInput_3[1]],
                        });
                    };
                    const matchValue_2 = langMenu.Status;
                    switch (matchValue_2.tag) {
                        case 1: {
                            return empty();
                        }
                        case 3:
                            return singleton_1(langToast(undefined));
                        case 2:
                            return singleton_1(langToast(matchValue_2.fields[0]));
                        default: {
                            return empty();
                        }
                    }
                }
            }
        }
        else {
            return empty();
        }
    })))))), ["application", react.createElement(react.Fragment, {}, ...elements)])])));
}

createRoot(document.getElementById("shopfoo-app")).render(createElement(AppView, null));

